/**
 * Rollin'Denims Product Experience - Vanilla JavaScript Component Logic
 * ADV TRIBE Staging Theme Implementation
 * Matches Claude Rollin Interactive Design Specification & Commerce Binding
 */

(function () {
  'use strict';

  // Canonical hip measurements in inches. Commerce pricing comes from Shopify variants.
  const HIP_DATA = {
    genesis: { 30: 38, 32: 40, 34: 42, 36: 44, 38: 46, 40: 48, 42: 50, 44: 52 },
    shadow: { 30: 38, 32: 40, 34: 42, 36: 44, 38: 46, 40: 48 },
    outlaw: { 30: 40, 32: 42, 34: 44, 36: 46, 38: 48, 40: 50 }
  };

  function formatMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN');
  }

  function formatProductMoney(cents) {
    return '₹' + (cents / 100).toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  /* ==========================================================================
     SPATIAL SELECTOR (Collection)
     ========================================================================== */
  function initSpatialSelector() {
    const selectorSec = document.querySelector('[data-rollin-spatial-selector]');
    if (!selectorSec) return;

    const panels = selectorSec.querySelectorAll('[data-rollin-panel]');
    const ghostEl = selectorSec.querySelector('[data-rollin-ghost]');
    const cardEl = selectorSec.querySelector('[data-rollin-card]');
    if (!panels.length || !cardEl) return;

    function activateModel(modelId) {
      panels.forEach(p => {
        const isActive = p.getAttribute('data-rollin-panel') === modelId;
        p.classList.toggle('is-active', isActive);
        p.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      // Update ghost background title
      const activePanel = selectorSec.querySelector(`[data-rollin-panel="${modelId}"]`);
      if (activePanel && ghostEl) {
        const name = activePanel.getAttribute('data-model-name') || modelId.toUpperCase();
        ghostEl.textContent = name.toUpperCase();
      }

      // Update card content from panel dataset
      if (activePanel) {
        const titleEl = cardEl.querySelector('[data-card-title]');
        const descEl = cardEl.querySelector('[data-card-desc]');
        const denimEl = cardEl.querySelector('[data-card-denim]');
        const silEl = cardEl.querySelector('[data-card-sil]');
        const sizesEl = cardEl.querySelector('[data-card-sizes]');
        const hipEl = cardEl.querySelector('[data-card-hip]');
        const startEl = cardEl.querySelector('[data-card-start]');
        const wiaEl = cardEl.querySelector('[data-card-wia]');
        const ctaEl = cardEl.querySelector('[data-card-cta]');
        const featListEl = cardEl.querySelector('[data-card-features]');

        if (titleEl) titleEl.textContent = activePanel.getAttribute('data-model-name') || '';
        if (descEl) descEl.textContent = (activePanel.getAttribute('data-model-desc') || '') + ' · CORE-X';
        if (denimEl) denimEl.textContent = activePanel.getAttribute('data-model-denim') || '';
        if (silEl) silEl.textContent = activePanel.getAttribute('data-model-sil') || '';
        if (sizesEl) sizesEl.textContent = activePanel.getAttribute('data-model-sizes') || '';
        if (hipEl) hipEl.textContent = activePanel.getAttribute('data-model-hip') || '';
        if (startEl) startEl.textContent = activePanel.getAttribute('data-model-start') || '';
        if (wiaEl) wiaEl.textContent = activePanel.getAttribute('data-model-wia') || '';
        if (ctaEl) {
          const url = (activePanel.getAttribute('data-model-url') || '').trim();
          if (url && url !== '') {
            ctaEl.style.display = '';
            ctaEl.textContent = 'View ' + (activePanel.getAttribute('data-model-name') || '');
            ctaEl.setAttribute('href', url);
          } else {
            ctaEl.style.display = 'none';
          }
        }

        // Features list
        if (featListEl) {
          const feats = JSON.parse(activePanel.getAttribute('data-model-features') || '[]');
          featListEl.innerHTML = '';
          feats.forEach(f => {
            const item = document.createElement('div');
            item.className = 'rollin-feature-item';
            item.innerHTML = '<span class="rollin-bullet-dot"></span><span class="rollin-feature-text">' + f + '</span>';
            featListEl.appendChild(item);
          });
        }
      }
    }

    panels.forEach((btn, index) => {
      btn.addEventListener('click', function () {
        const id = this.getAttribute('data-rollin-panel');
        activateModel(id);
      });

      // Keyboard arrow navigation
      btn.addEventListener('keydown', function (e) {
        let targetIndex = -1;
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          targetIndex = (index + 1) % panels.length;
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          targetIndex = (index - 1 + panels.length) % panels.length;
        }
        if (targetIndex >= 0) {
          e.preventDefault();
          panels[targetIndex].focus();
          const targetId = panels[targetIndex].getAttribute('data-rollin-panel');
          activateModel(targetId);
        }
      });
    });
  }

  /* ==========================================================================
     PDP SIZING & ARMOUR CONTROLS
     ========================================================================= */
  function initRollinPDPControls() {
    const buyBox = document.querySelector('[data-rollin-buy-box]');
    if (!buyBox) return;
    if (typeof buyBox.__rollinUpdateSelection === 'function') return;

    const modelType = (buyBox.getAttribute('data-rollin-model') || 'genesis').toLowerCase();
    const hipBySize = HIP_DATA[modelType] || HIP_DATA.genesis;

    let selectedSize = parseInt(buyBox.getAttribute('data-selected-size') || '34', 10);
    let selectedArmour = buyBox.getAttribute('data-selected-armour') || 'woa'; // 'woa' or 'wia'

    const sizeChips = buyBox.querySelectorAll('[data-rollin-size-chip]');
    const hipReadout = buyBox.querySelector('[data-rollin-hip-readout]');
    const sizeReadout = buyBox.querySelector('[data-rollin-size-readout]');
    const sizeSelectedLabel = buyBox.querySelector('[data-rollin-selected-size-label]');

    const armourBtns = buyBox.querySelectorAll('[data-rollin-armour-btn]');
    const priceDisplay = buyBox.querySelector('[data-rollin-price-display]');
    const pi1Summary = buyBox.querySelector('[data-rollin-pi1-summary]');
    const variantsScript = buyBox.querySelector('[data-rollin-variants-json]');
    const productForm = document.querySelector('.main-product-form');
    const variantIdInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    const addToCartButton = productForm ? productForm.querySelector('button[name="add"]') : null;
    const addToCartText = addToCartButton ? addToCartButton.querySelector('.atc-text') : null;
    const dynamicCheckout = productForm ? productForm.querySelector('.prod__dynamic_checkout') : null;
    const availableButtonText = addToCartButton
      ? addToCartButton.getAttribute('data-atc-text') || (addToCartText ? addToCartText.textContent.trim() : '')
      : '';
    const soldOutButtonText = buyBox.getAttribute('data-rollin-sold-out-text') || 'Sold out';
    const primaryPriceDisplay = document.querySelector(
      '.main-product__block-price .f-price__regular .f-price-item--regular'
    );
    let variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (err) {
        console.error('Error parsing Rollin variants JSON:', err);
      }
    }

    const variantByOptions = new Map(variants.map(variant => [
      String(variant.size) + '|' + String(variant.armour),
      variant
    ]));

    const initialVariant = variantIdInput
      ? variants.find(variant => String(variant.id) === String(variantIdInput.value))
      : null;

    if (initialVariant) {
      selectedSize = parseInt(initialVariant.size, 10);
      selectedArmour = initialVariant.armour === 'With Armour' ? 'wia' : 'woa';
    }

    function getVariant(size, armourCode) {
      const armourLabel = armourCode === 'wia' ? 'With Armour' : 'Without Armour';
      return variantByOptions.get(String(size) + '|' + armourLabel);
    }

    function setSubmissionState(variant) {
      const canSubmit = Boolean(variant && variant.available);

      if (variantIdInput) {
        variantIdInput.value = variant ? variant.id : '';
        variantIdInput.disabled = !canSubmit;
        variantIdInput.setAttribute('data-selected-variant', variant ? variant.id : '');
      }

      if (addToCartButton) {
        addToCartButton.disabled = !canSubmit;
        addToCartButton.classList.toggle('disabled', !canSubmit);
        addToCartButton.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      }

      if (addToCartText) {
        addToCartText.textContent = canSubmit ? availableButtonText : soldOutButtonText;
      }

      if (dynamicCheckout) {
        dynamicCheckout.classList.toggle('disabled', !canSubmit);
        dynamicCheckout.setAttribute('aria-disabled', canSubmit ? 'false' : 'true');
      }
    }

    function updateControlAvailability() {
      sizeChips.forEach(chip => {
        const size = parseInt(chip.getAttribute('data-size'), 10);
        const hasAvailableVariant = ['woa', 'wia'].some(armourCode => {
          const variant = getVariant(size, armourCode);
          return Boolean(variant && variant.available);
        });
        chip.disabled = !hasAvailableVariant;
        chip.setAttribute('aria-disabled', hasAvailableVariant ? 'false' : 'true');
      });

      armourBtns.forEach(btn => {
        const variant = getVariant(selectedSize, btn.getAttribute('data-armour'));
        const isAvailable = Boolean(variant && variant.available);
        btn.disabled = !isAvailable;
        btn.setAttribute('aria-disabled', isAvailable ? 'false' : 'true');
      });
    }

    function updateCalculations() {
      const selectedVariant = getVariant(selectedSize, selectedArmour);
      const withoutArmourVariant = getVariant(selectedSize, 'woa');
      const withArmourVariant = getVariant(selectedSize, 'wia');

      updateControlAvailability();
      setSubmissionState(selectedVariant);

      if (!selectedVariant) {
        console.error('Rollin variant not found for selection:', selectedSize, selectedArmour);
        return;
      }

      // 1. Dynamic Size Readout (ONLY that size's exact Hip and Inseam)
      const hipVal = hipBySize[selectedSize] || '--';
      if (hipReadout) hipReadout.textContent = hipVal + ' in';
      if (sizeReadout) sizeReadout.textContent = selectedSize;
      if (sizeSelectedLabel) sizeSelectedLabel.textContent = selectedSize;

      // Update state attributes on container
      buyBox.setAttribute('data-selected-size', selectedSize);
      buyBox.setAttribute('data-selected-armour', selectedArmour);

      // 2. Active chip classes
      sizeChips.forEach(chip => {
        const s = parseInt(chip.getAttribute('data-size'), 10);
        const active = s === selectedSize;
        chip.classList.toggle('is-active', active);
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // 3. Native Shopify variant and price state
      if (priceDisplay) {
        priceDisplay.textContent = formatMoney(selectedVariant.price);
      }
      if (primaryPriceDisplay) {
        primaryPriceDisplay.textContent = formatProductMoney(selectedVariant.price);
      }

      // Update Armour button prices
      const woaPriceEl = buyBox.querySelector('[data-rollin-woa-price]');
      const wiaPriceEl = buyBox.querySelector('[data-rollin-wia-price]');
      if (woaPriceEl && withoutArmourVariant) woaPriceEl.textContent = formatMoney(withoutArmourVariant.price);
      if (wiaPriceEl && withArmourVariant) wiaPriceEl.textContent = formatMoney(withArmourVariant.price);

      // Update Armour active states
      armourBtns.forEach(btn => {
        const arm = btn.getAttribute('data-armour');
        const active = arm === selectedArmour;
        btn.classList.toggle('is-active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      // Update PI-1 summary line
      if (pi1Summary) {
        const armLabel = selectedArmour === 'wia' ? 'With Armour' : 'Without Armour';
        pi1Summary.innerHTML = 'Size ' + selectedSize + '<br>' + armLabel;
      }

      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', selectedVariant.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    buyBox.__rollinUpdateSelection = function (nextSize, nextArmour) {
      const candidateSize = parseInt(nextSize, 10);
      const candidateArmour = nextArmour;
      const candidateVariant = getVariant(candidateSize, candidateArmour);

      if (!candidateVariant) {
        setSubmissionState(null);
        console.error('Rollin variant not found for selection:', candidateSize, candidateArmour);
        return;
      }

      selectedSize = candidateSize;
      selectedArmour = candidateArmour;
      updateCalculations();
    };

    // Initial render calculation
    updateCalculations();
  }

  function bindRollinPDPEvents() {
    if (document.__rollinPDPEventsBound) return;
    document.__rollinPDPEventsBound = true;

    document.addEventListener('click', function (event) {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const sizeChip = target.closest('[data-rollin-size-chip]');
      const armourButton = target.closest('[data-rollin-armour-btn]');
      const control = sizeChip || armourButton;
      if (!control) return;

      const buyBox = control.closest('[data-rollin-buy-box]');
      if (!buyBox) return;
      if (typeof buyBox.__rollinUpdateSelection !== 'function') {
        initRollinPDPControls();
      }
      if (typeof buyBox.__rollinUpdateSelection !== 'function') return;

      const nextSize = sizeChip
        ? sizeChip.getAttribute('data-size')
        : buyBox.getAttribute('data-selected-size');
      const nextArmour = armourButton
        ? armourButton.getAttribute('data-armour')
        : buyBox.getAttribute('data-selected-armour');

      buyBox.__rollinUpdateSelection(nextSize, nextArmour);
    });
  }

  /* ==========================================================================
     ARMOUR POCKET REVEAL (PDP Interactive Tabs)
     ========================================================================== */
  function initArmourPocketTabs() {
    const pocketSec = document.querySelector('[data-rollin-pocket-sec]');
    if (!pocketSec) return;

    const tabBtns = pocketSec.querySelectorAll('[data-pocket-tab]');
    const imgEl = pocketSec.querySelector('[data-pocket-img]');
    const capEl = pocketSec.querySelector('[data-pocket-cap]');

    tabBtns.forEach(btn => {
      btn.addEventListener('click', function () {
        const tab = this.getAttribute('data-pocket-tab');
        tabBtns.forEach(b => {
          const active = b === this;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        const newImg = this.getAttribute('data-pocket-src');
        const newCap = this.getAttribute('data-pocket-desc');
        const newAlt = this.getAttribute('data-pocket-alt');

        if (imgEl && newImg) {
          imgEl.src = newImg;
          if (newAlt) imgEl.alt = newAlt;
        }
        if (capEl && newCap) {
          capEl.textContent = newCap;
        }
      });
    });
  }

  function initRollinExperience() {
    bindRollinPDPEvents();
    initSpatialSelector();
    initRollinPDPControls();
    initArmourPocketTabs();
  }

  // Custom Liquid can load this deferred asset after DOMContentLoaded in theme
  // preview. Initialize immediately when the document is already ready.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRollinExperience, { once: true });
  } else {
    initRollinExperience();
  }

  // Re-run if Shopify section renders dynamically in Theme Customizer
  document.addEventListener('shopify:section:load', function () {
    bindRollinPDPEvents();
    initSpatialSelector();
    initRollinPDPControls();
    initArmourPocketTabs();
  });
})();
